module.exports = __webpack_public_path__ + "img/quebra-cabeca.1f144a7a.png";